class GoogleDirectionsRendererController {
    constructor($scope) {
        this.directionsRenderer = new google.maps.DirectionsRenderer(this.directionsRendererOptions);

        $scope.$watch(
            () => this.directions,
            () => this.setDirections(this.directions),
        );

        $scope.$watch(
            () => this.routeIndex,
            () => this.setRouteIndex(this.routeIndex),
        );
    }

    setDirections(directions) {
        if (directions) {
            this.directionsRenderer.setDirections(directions);
            this.setRouteIndex(this.routeIndex);
        }
    }

    setRouteIndex(routeIndex) {
        if (routeIndex != null) {
            this.directionsRenderer.setRouteIndex(routeIndex);
        }
    }

    setMap(map) {
        this.map = map;
        this.directionsRenderer.setMap(map);
    }
}

const googleDirectionsRendererDirectiveDefinition = () => ({
    restrict: 'E',
    require: ['olyGoogleDirectionsRenderer', '^olyGoogleMap'],
    scope: {},
    bindToController: {
        directionsRenderer: '=?',
        directionsRendererOptions: '=?',
        directions: '=',
        routeIndex: '=',
    },
    controller: ['$scope', GoogleDirectionsRendererController],
    controllerAs: 'googleDirectionsRendererCtrl',
    link(scope, element, attrs, controllers) {
        const directionsRendererCtrl = controllers[0];
        const mapCtrl = controllers[1];

        directionsRendererCtrl.setMap(mapCtrl.getMap());
    },
});

module.exports = {
    GoogleDirectionsRendererController,
    googleDirectionsRendererDirectiveDefinition,
};



// WEBPACK FOOTER //
// ./src/olycommon/googlemaps/google-directions-renderer.directive.js